// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__Z9p8D","placeHolderShimmer":"ReportFilter_placeHolderShimmer__0nDuh"};